import type { Nullable } from '~/core/types'

/**
 * Retourne l'id à partir de l'url (78-lorem-ipsum => 78)
 * @param slug
 */
const getIdFromSlug = (slug: Nullable<string>): string => {
  const regex = /^([0-9]*)[a-z-]*$/
  if (!slug) {
    throw new Error(`Slug is empty`)
  }
  const matches = slug.match(regex)
  if (!matches || !matches[1]) {
    throw new Error(`Slug has invalid value`)
  }
  return matches[1]
}

const stringToSlug = (str: string) => {
  str = str.replace(/^\s+|\s+$/g, '')
  str = str.toLowerCase()

  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaeeeeiiiioooouuuunc------'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }
  str = str
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')

  return str
}

export { getIdFromSlug, stringToSlug }
